import moment from 'moment'
import type { CalendarEvent } from 'paintscout'

export function groupEventsByEstimator(events: CalendarEvent[]): CalendarEvent[] {
  // Group by estimatorId + startDate + endDate
  const groupedEvents = events.reduce<Record<string, Record<string, Record<string, CalendarEvent[]>>>>((acc, event) => {
    const { id: estimatorId } = event.estimator
    const eventStartDate = moment(event.start).format('YYYY-MM-DD')
    const eventEndDate = moment(event.end).format('YYYY-MM-DD')

    acc[estimatorId] = acc[estimatorId] || {}
    acc[estimatorId][eventStartDate] = acc[estimatorId][eventStartDate] || {}
    acc[estimatorId][eventStartDate][eventEndDate] = acc[estimatorId][eventStartDate][eventEndDate] || []
    acc[estimatorId][eventStartDate][eventEndDate].push(event)

    return acc
  }, {})

  const eventsWithSubevents = events.reduce<CalendarEvent[]>((result, event) => {
    const { id: estimatorId } = event.estimator
    const eventStartDate = moment(event.start).format('YYYY-MM-DD')
    const eventEndDate = moment(event.end).format('YYYY-MM-DD')
    const group = groupedEvents[estimatorId]?.[eventStartDate]?.[eventEndDate] ?? []

    // Only push the first event in the group, with subsequentEvents attached
    if (group.length && group[0].id === event.id) {
      result.push({ ...event, subsequentEvents: group.slice(1) })
    }

    return result
  }, [])

  return eventsWithSubevents
}
